import { render } from "./DialogsOld.vue?vue&type=template&id=68ff18da&scoped=true&lang=pug"
import script from "./Dialogs.js?vue&type=script&lang=js&external"
export * from "./Dialogs.js?vue&type=script&lang=js&external"

import "./DialogsOld.vue?vue&type=style&index=0&id=68ff18da&lang=scss&scoped=true"
import "./DialogsOld.vue?vue&type=style&index=1&id=68ff18da&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ff18da"]])

export default __exports__